import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC } from 'react'

import AngleRight from '@Assets/SVG/AngleRight'
import { Breadcrumb } from '@Components/Breadcrumbs/breadcrumb'
import { Link } from '@Components/Link'

import styles from './Breadcrumbs.module.scss'

interface BreadcrumbProps {
  breadcrumbs: Breadcrumb[]
  categoryBreadcrumb?: boolean
  className?: string
}

export const Breadcrumbs: FC<BreadcrumbProps> = ({ breadcrumbs, categoryBreadcrumb, className }) => {
  let mainCategoryIndex = breadcrumbs.findIndex(breadcrumb => breadcrumb.type === 'categories')
  if (mainCategoryIndex === -1) {
    mainCategoryIndex = 0
  }

  return (
    <ol className={clsx(className, styles.breadcrumbs, categoryBreadcrumb && styles.categoryBreadcrumb)} itemScope itemType="https://schema.org/BreadcrumbList">
      {map(breadcrumbs, (crumb, index) => {
        const { title, type = '', url } = crumb
        return (
          <li
            key={`${title}${url}`}
            className={clsx(
              styles.crumb,
              index === mainCategoryIndex && styles.mainCategory,
            )}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <AngleRight className={styles.angle} />

            {url
              ? (
                <>
                  <Link
                    key={`${index}`}
                    analytics={{
                      dest_page_type: type,
                      dest_page_type_id: '',
                      source_id: 'bread_crumb',
                    }}
                    href={url || '/'}
                    itemProp="item"
                  >
                    <span itemProp="name">{title}</span>
                  </Link>
                  <meta content={`${index + 1}`} itemProp="position" />
                </>
              )
              : (
                <>
                  <span itemProp="name">{title}</span>
                  <meta content={`${index + 1}`} itemProp="position" />
                </>
              )}

          </li>
        )
      })}
    </ol>
  )
}
